











































import Vue from "vue";
import InvoiceGroupApproval from "../models/InvoiceGroupApproval";
import store, { InvoiceGroupApprovalStore } from "../services/InvoiceGroupApprovalStore";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import IconButton from "@/components/IconButton.vue";
import Tooltip from "@/components/Tooltip.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import configuration, { AppConfiguration } from "@/models/Configuration";
import { t } from "@/plugins/i18n";

interface Data {
  store: InvoiceGroupApprovalStore;
  configuration: AppConfiguration;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    ApiSearchPage,
  },

  data() {
    return {
      store,
      configuration,
    };
  },

  methods: {
    clickHandler(item: any) {
      if (!configuration.invoiceFlow.enabled) {
        this.$router.push(`/general-incoming-invoice/edit/${item.partnerId}/${item.invId}`);
      } else {
        this.$router.push(`/general-incoming-invoice/flow/edit/${item.invId}/5`);
      }
    },
  },

  computed: {
    columns: (): ApiSearchColumn[] => [
      {
        field: "invId",
        title: t("GENISzam"),
        cell: "invIdCell",
      },
      {
        field: "invNo",
        title: t("BizonylatSzam"),
      },
      { field: "regCode", title: t("RendelesSzam") },
      { field: "partsName", title: t("Cikk") },
      {
        field: "partCode",
        title: t("Cikkszam"),
      },
      {
        field: "invGroupName",
        title: t("InvoiceGroupApproval_Koltseghley"),
      },
      {
        field: "netto",
        title: t("Netto"),
        type: ColumnType.Money,
      },
      { field: "currency", title: t("Penznem") },
      {
        field: "approvalTypeName",
        title: t("Jovahagyas"),
      },
      {
        field: "typeName",
        title: t("TetelTipus"),
      },
      {
        field: "modUser",
        title: t("Modosito"),
      },
      {
        field: "daysSpentInStatus",
        title: t("InvoiceGroupApproval_JovahagyasraVar"),
        cell: "daysSpentInStatusTemplate",
      },
      {
        field: "apprType",
        title: t("Tipus"),
      },
      { sortable: false, filterable: false },
    ],
  },
});
